import React, { useId } from 'react';
import './Logo.css';

// Care Linq mark: a lab flask with a care cross cut out of it, on a rounded
// badge. color="blue" for light backgrounds, "white" for the blue sidebar.
// public/favicon.svg is the same drawing (blue) for the browser tab.
const Logo = ({
  width = '100px',
  height = '100px',
  color = 'blue'
}) => {
  const gradientId = `logo-grad-${useId().replace(/:/g, '')}`;
  const white = color === 'white';
  const badge = white ? '#fff' : `url(#${gradientId})`;
  const flask = white ? '#2c6bd7' : '#fff';

  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label="Care Linq"
      style={{ width, height, display: 'inline-block', verticalAlign: 'middle' }}
    >
      {!white && (
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#1f5fd1" />
            <stop offset="1" stopColor="#3fa9f5" />
          </linearGradient>
        </defs>
      )}
      <rect width="64" height="64" rx="15" fill={badge} />
      <rect x="23" y="9" width="18" height="5" rx="2.5" fill={flask} />
      <path d="M27 13V26.5L15.6 46.2C13.9 49.2 16 53 19.5 53H44.5C48 53 50.1 49.2 48.4 46.2L37 26.5V13Z" fill={flask} />
      <rect x="29.75" y="35" width="4.5" height="13" rx="1.2" fill={badge} />
      <rect x="25.5" y="39.25" width="13" height="4.5" rx="1.2" fill={badge} />
    </svg>
  );
};

export default Logo;
